module.exports = __webpack_public_path__ + "42f0ff79a75a61a12521faa422fd1579.png";